<template lang="pug">
.reservationAlertModal
  .reservationAlertModal__popup
    h3.reservationAlertModal__title 提醒您，您只能預約15分鐘後行程
    .reservationAlertModal__radioWrapper(
      @click="$emit('toggleCheckPreventAlert')"
    )
      RadioCheckedUI.reservationAlertModal__radio(
        :isChecked="isChecked"
      )
      p.reservationAlertModal__text 下次不再提醒
    .reservationAlertModal__btnWrapper
      BaseBtnConfirm.reservationAlertModal__btn(
        :text="'確定'"
        @click="$emit('alertConfirmed')"
      )
</template>

<script>
import RadioCheckedUI from '@/components/common/RadioCheckedUI'
import BaseBtnConfirm from '@/components/BaseComponent/BaseBtnConfirm'

export default {
  props: {
    isChecked: {
      type: Boolean,
      required: true,
    },
  },
  components: {
    BaseBtnConfirm,
    RadioCheckedUI,
  },
}
</script>

<style lang="scss" scoped>
.reservationAlertModal {
  position: fixed;
  left: 0;
  top: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 20;

  &__popup {
    width: 296px;
    min-height: 208px;
    border-radius: 20px;
    background-color: #ffffff;
    padding-top: 24px;
    padding-bottom: 16px;
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
  }

  &__radioWrapper {
    margin-top: 8px;
    padding: 0 8px;
    height: 56px;
    display: flex;
    align-items: center;
  }

  &__radio {
    margin-left: 26px;
  }

  &__title {
    margin: 0;
    padding: 0 20px;
    line-height: 28px;
    font-size: 20px;
    font-weight: 500;
    color: rgba(0, 0, 0, 0.87);
  }

  &__text {
    font-size: 14px;
    margin-left: 24px;
  }

  &__btnWrapper {
    margin-top: auto;
    padding: 0 16px;
  }

  &__btn {
    width: 100%;
    max-width: 264px;
    margin: 0 auto;
  }
}
</style>
